import React, { useMemo, useState } from "react";
import { Badge, Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import {
  CustomInput,
  SearchBox,
  ChatSearchButton,
  SmallIcon,
} from "../../../common/chatComponents/ScreenSearchSection";
import PersonIcon from "../../../assets/images/chats/person.svg";
import searchIcon from "../../../assets/images/chats/gallery_active.svg";
import { StyledSideBarHeader, StyledSideBarInfoBox, StyledSidebarInvitesButton, StyledSidebarTopicButton, createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import addIcom from "../../../assets/images/chats/Add.svg";
import addBlackIcom from "../../../assets/images/chats/AddBlack.svg";
import { useDispatch } from "react-redux";
import { requestArchiveGroup } from "../../../appStore/actions/ArkchatGroup/action";
import ProfileDetailModal from "../../../common/ProfileDetailModal";
import group_icon from "../../../assets/images/chats/group_icon.svg";
import Archived from "../../../assets/images/chats/archived.svg";
import buyer_seller_grp_icon from "../../../assets/images/chats/buyer_seller_grp_icon.svg";
import moment from "moment";
import { colorSchemes, crossIconDiv, personIconStyle } from "../../../assets/commonFunction";
import InviteMemberDrawer from "../Drawer/InviteMemberDrawer";
import Archive from "../../../common/SvgImageView/Archive";
import UnArchive from "../../../common/SvgImageView/UnArchive";
import useAppSelectors from "../../../customHooks/useAppSelectors";

const classes = {
  headingText: {
    color: "black",
    fontSize: "14px",
    fontWeight: "400",
    "@media (max-width: 63em)": {
      fontSize: "0.8rem",
    },
  },
  selectedItem: {
    backgroundColor: "#E1E1E1",
    color: "#000",
  },
  nonselectedItem: {
    color: "#000",
  },
};

const SideBar = ({
  setisTopicOpen,
  handlecreategroup,
  handlegroupItemclick,
  handleFlipToArchiveGroupList,
}) => {
  const { t } = useTranslation();
  const [showArchiveIcons, setShowArchiveIcons] = useState(false);
  const [showUnArchiveIcons, setShowUnArchiveIcons] = useState(false);
  const [showArchiveList, setShowArchiveList] = useState(false);
  const appContent = t("AppContent", { returnObjects: true });
  const dispatch = useDispatch();
  const { selectedGroup, groupList, archiveGroupList } = useAppSelectors();

  const SmallActionButton = createStyledIndicatorButton("#E3E1E1");
  const [isInviteOpen, setInviteOpen] = useState(false);
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [profileViewData, setProfileViewData] = useState("");
  const [search, setSearch] = useState("");
  const [archiveSearch, setArchiveSearch] = useState("");
  const { currentUserData } = useAppSelectors();

  const handleOpenMenu = () => {
    setInviteOpen(true);
  };

  const handleCloseMenu = () => {
    setInviteOpen(false);
  };

  const filteredGroups = useMemo(() => {
    if (!search) return groupList;

    return groupList.filter((item) =>
      item?.name?.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, groupList]);

  const filteredArchiveGroups = useMemo(() => {
    if (!archiveSearch) return archiveGroupList;

    return archiveGroupList.filter((item) =>
      item?.name?.toLowerCase().includes(archiveSearch.toLowerCase())
    );
  }, [archiveSearch, archiveGroupList]);

  const handleOnSearchGroup = (event) => {
    if(showArchiveList){
      setArchiveSearch(event.target.value);
      return;
    }
    setSearch(event.target.value);
  };

  const handleGroupProfileBadgeClick = (
    data,
    isGroup,
    isBuyerSellerGroup = false
  ) => {

    const viewData = {
      companyName:
        data?.accountDetails?.subscriberFirmName ||
        data?.activeSubscriber?.subscriberFirmName,
      userName: isGroup
        ? null
        : data?.name || `${data?.firstName} ${data?.lastName}`,
      industryName:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.activeSubscriber?.subscriberAccountIndustry,
      cityName: data?.accountDetails?.city || data?.city,
      industry:
        data?.accountDetails?.subscriberAccountIndustry ||
        data?.subscriberAccountIndustry,
      type:
        data?.accountDetails?.subscriberAccountType ||
        data?.subscriberAccountType,
      countryName: data?.accountDetails?.country || data?.country,
      profileBrief: data?.accountDetails?.profileBrief || data?.profileBrief,
      profileImgUrl: data?.accountDetails?.profileImgUrl || data?.profileImgUrl,
      coverImgUrl: data?.accountDetails?.coverImgUrl || data?.coverImgUrl,
      isGroup: isGroup,
      isBuyerSellerGroup: isBuyerSellerGroup,
      website: data?.accountDetails?.website || data?.website,
      linkedin: data?.accountDetails?.linkedin || data?.linkedin,
      joinedDate: data?.joinedDate
        ? new Date(
            Number(String(data?.joinedDate).slice(0, 13))
          ).toLocaleDateString()
        : data?.joinedDate,
      memberCount: data?.memberCount || data?.memberCount,
      createdDate: data?.createdDate
        ? new Date(
            Number(String(data?.createdDate).slice(0, 13))
          ).toLocaleDateString()
        : data?.createdDate,
      groupName: data?.name,
      groupOwner: data?.createdByUserDetails
        ? `${data.createdByUserDetails.firstName || ""} ${
            data.createdByUserDetails.lastName || ""
          }`.trim()
        : "-",
      description: data?.description,
      email: data?.createdByUserDetails?.email,
    };    
    setProfileViewData(viewData);
    setProfileViewModal(true);
  };

  const handleArchiveClick = (item) => {
    dispatch(requestArchiveGroup(item?.pnId));
    setShowArchiveIcons(false);
    setShowUnArchiveIcons(false);
  };

  const handleShowArchiveList = (action) => {
    handleFlipToArchiveGroupList();
    setisTopicOpen(false);
    setShowArchiveList(action);
    setSearch("");
    setArchiveSearch("");
  };

  return (
    <Stack bgcolor={"#F9F8F8"}>
      <ProfileDetailModal
        setProfileViewModal={setProfileViewModal}
        isProfileViewOpen={isProfileViewOpen}
        profileViewData={profileViewData}
        setProfileViewData={setProfileViewData}
      />
      <StyledSideBarHeader
        sx={{
          bgcolor: "#efefef",
          alignItems: "center",
        }}
        position={"relative"}
      >
        {!showArchiveList && (
          <>
            <Box
              display="flex"
              alignItems="center"
              gap={"0.5rem"}
              marginLeft={"0.1rem"}
            >
              <Typography sx={classes.headingText} variant="h6">
                {appContent?.KEY197}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }} gap={"0.3rem"}>
              <Button
                onClick={() => setShowArchiveIcons(!showArchiveIcons)}
                size="small"
                variant="contained"
                sx={{
                  padding: "0px",
                  border: `0.5px solid ${colorSchemes.black}`,
                  backgroundColor: showArchiveIcons
                    ? `${colorSchemes.chipIconBlueColor}`
                    : `${colorSchemes.white}`,
                  width: "1.87rem",
                  height: "1.87rem",
                  minWidth: "unset",
                  minHeight: "unset",
                  borderRadius: "0.15rem",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: showArchiveIcons
                      ? `${colorSchemes.chipIconBlueColor}`
                      : `${colorSchemes.white}`,
                    boxShadow: "none",
                  },
                }}
              >
                <Archive color={showArchiveIcons ? "#FFFF" : "#000000"} />
              </Button>

              <StyledSidebarTopicButton
                sx={{ display: "flex", alignItems: "center", gap: "0.2rem" }}
                onClick={handlecreategroup}
                size="small"
              >
                <img src={addBlackIcom} alt="group" />
                {appContent?.KEY195}
              </StyledSidebarTopicButton>
            </Box>
          </>
        )}
        {showArchiveList && (
          <>
            <Box display="flex" alignItems="center" gap={"0.5rem"}>
              <>
                <CloseIcon
                  sx={{ ...crossIconDiv }}
                  onClick={() => handleShowArchiveList(false)}
                />
              </>
              <Box>
                <Typography sx={classes.headingText} variant="h6">
                  Archived
                </Typography>
              </Box>
            </Box>
            <Box>
              <StyledSidebarTopicButton
                onClick={() => setShowUnArchiveIcons(true)}
                sx={{ display: "flex", alignItems: "center", gap: "0.2rem" }}
                size="small"
              >
                Unarchive
              </StyledSidebarTopicButton>
            </Box>
          </>
        )}
      </StyledSideBarHeader>

      <StyledSideBarInfoBox>
          <Box
            display="flex"
            gap={"8px"}
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Box width={"100%"}>
              <SearchBox>
                <CustomInput
                  value={search||archiveSearch}
                  placeholder={appContent?.KEY303}
                  onChange={handleOnSearchGroup}
                />
                <ChatSearchButton size="small" variant="contained">
                  <SmallIcon src={searchIcon} />
                </ChatSearchButton>
              </SearchBox>
            </Box>
          </Box>

        <Box
          bgcolor={"#F9F8F8"}
          display="flex"
          flexDirection="column"
          alignItems="center"
          mt={"0.4rem"}
          rowGap={"0.4rem"}
          overflow={"scroll"}
          height={"calc(100vh - 16rem)"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "0px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#F9F8F8",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "grey",
            },
            "@media (max-width: 1194px)": {
              height: "calc(100vh - 18rem)",
            },
          }}
        >
          {!showArchiveList && archiveGroupList?.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                cursor: "pointer",
                borderRadius: "0.1rem",
              }}
            >
              <Box
                width="1.99rem"
                height="1.89rem"
                borderRadius="2px"
                display="flex"
                justifyContent="center"
                backgroundColor="#E3E1E1"
                sx={{
                  padding: "6px",
                  overflow: "hidden",
                }}
              >
                <img src={Archived} alt="archived" style={{ width: "20px" }} />
              </Box>
              <Box onClick={() => handleShowArchiveList(true)} width="100%" ml="1.2rem">
                <Typography fontSize="13px" fontWeight="400" color="black">
                  Archived({archiveGroupList?.length||0})
                </Typography>
              </Box>
            </div>
          )}

          {!showArchiveList && (
            <>
              {filteredGroups?.map((item, i) => {
                return (
                  <div
                    key={item?.id + "groupList" + i + "unique"}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box
                      width={"75%"}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.1rem",
                        cursor: "pointer",
                      }}
                    >
                      <Box width={"15%"}>
                        <SmallActionButton
                          size="small"
                          variant="contained"
                          sx={{
                            padding:
                              item?.accountDetails?.profileImgUrl &&
                              !item?.isGroup
                                ? "0px"
                                : "6px",
                            overflow: "hidden",
                          }}
                          onClick={() =>
                            item?.isGroup
                              ? handleGroupProfileBadgeClick(
                                  item,
                                  item?.isGroup,
                                  item?.isBuyerSellerGroup
                                )
                              : handleGroupProfileBadgeClick(
                                  item,
                                  item?.isGroup
                                )
                          }
                        >
                          {item?.isGroup ? (
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={
                                item?.isBuyerSellerGroup
                                  ? buyer_seller_grp_icon
                                  : group_icon
                              }
                              alt="group"
                            />
                          ) : (
                            <>
                              {item?.accountDetails?.profileImgUrl ? (
                                <img
                                  style={{ width: "100%", height: "100%" }}
                                  src={item?.accountDetails?.profileImgUrl}
                                  alt=""
                                />
                              ) : (
                                <img
                                  style={personIconStyle}
                                  src={PersonIcon}
                                  alt="individual"
                                />
                              )}
                            </>
                          )}
                        </SmallActionButton>
                      </Box>

                      <Box
                        width={"84%"}
                        sx={
                          selectedGroup?.pnId === item?.pnId &&
                          selectedGroup?.name === item?.name
                            ? classes?.selectedItem
                            : classes?.nonselectedItem
                        }
                        padding={"0.2rem 0.4rem"}
                        borderRadius="0.1rem"
                        cursor="pointer"
                        onClick={() => handlegroupItemclick(item)}
                        position={"relative"}
                      >
                        <Box display={"flex"} alignItems={"center"}>
                          <Typography
                            maxWidth={
                              !item?.isGroup &&
                              item?.id === currentUserData?.id
                                ? "60%"
                                : "80%"
                            }
                            fontSize="13px"
                            fontWeight="400"
                            color={
                              selectedGroup?.id === item?.id ? "black" : "black"
                            }
                            variant="h6"
                            title={item?.name}
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.name}
                          </Typography>
                          {!item?.isGroup &&
                            item?.id === currentUserData?.id && (
                              <Typography ml={"0.1rem"} variant="caption">
                                ({appContent?.KEY5})
                              </Typography>
                            )}
                        </Box>
                        {item?.messageCount !== 0 &&
                          item?.pnId !== selectedGroup?.pnId && (
                            <Box
                              position={"absolute"}
                              right={"10%"}
                              top={"48%"}
                              sx={{ transform: "translateY(-48%)" }}
                            >
                              <Badge
                                color="success"
                                badgeContent={item?.messageCount}
                                max={20}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    backgroundColor: "#183243",
                                    fontSize: "0.7rem",
                                  },
                                }}
                              ></Badge>
                            </Box>
                          )}
                      </Box>
                    </Box>

                    {showArchiveIcons ? (
                      <Box
                        padding={"0rem 0.1rem 0rem 0rem"}
                        width={"25%"}
                        textAlign={"right"}
                      >
                        <Button
                          onClick={() => handleArchiveClick(item)}
                          size="small"
                          variant="contained"
                          sx={{
                            padding: "0px",
                            border: `0.5px solid ${colorSchemes.black}`,
                            backgroundColor: `${colorSchemes.white}`, // always white
                            width: "1.87rem",
                            height: "1.87rem",
                            minWidth: "unset",
                            minHeight: "unset",
                            borderRadius: "0.15rem",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: `${colorSchemes.white}`, // no blue on hover
                              boxShadow: "none",
                            },
                          }}
                        >
                          <Archive
                            color={showArchiveIcons ? "#000000" : "#000000"}
                          />{" "}
                          {/* always black */}
                        </Button>
                      </Box>
                    ) : (
                      item?.timetoken !== 0 &&
                      item?.timetoken && (
                        <Box
                          padding={"0rem 0.1rem 0rem 0rem"}
                          width={"25%"}
                          textAlign={"right"}
                        >
                          <Typography
                            variant="h6"
                            fontSize={"0.74rem"}
                            fontWeight={500}
                            color={"#183243"}
                          >
                            {(() => {
                              const timetoken = item?.timetoken;
                              const date = moment(
                                Math.floor(timetoken / 10000)
                              );
                              const isToday = date.isSame(moment(), "day");
                              return isToday
                                ? date.format(
                                    currentUserData?.userTimeFormat
                                  )
                                : date.format(
                                    currentUserData?.userDateFormat
                                  );
                            })()}
                          </Typography>
                        </Box>
                      )
                    )}
                  </div>
                );
              })}
            </>
          )}

          {/* Archived List */}
          {showArchiveList && (
            <>
              {filteredArchiveGroups?.map((item, i) => {
                return (
                  <div
                    key={item?.id + "archiveGroupList" + i + "unique"}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box
                      width={"75%"}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.1rem",
                        cursor: "pointer",
                      }}
                    >
                      <Box width={"15%"}>
                        <SmallActionButton
                          size="small"
                          variant="contained"
                          sx={{
                            padding:
                              item?.accountDetails?.profileImgUrl &&
                              !item?.isGroup
                                ? "0px"
                                : "6px",
                            overflow: "hidden",
                          }}
                          onClick={() =>
                            item?.isGroup
                              ? handleGroupProfileBadgeClick(
                                  item,
                                  item?.isGroup,
                                  item?.isBuyerSellerGroup
                                )
                              : handleGroupProfileBadgeClick(
                                  item,
                                  item?.isGroup
                                )
                          }
                        >
                          {item?.isGroup ? (
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={
                                item?.isBuyerSellerGroup
                                  ? buyer_seller_grp_icon
                                  : group_icon
                              }
                              alt="group"
                            />
                          ) : (
                            <>
                              {item?.accountDetails?.profileImgUrl ? (
                                <img
                                  style={{ width: "100%", height: "100%" }}
                                  src={item?.accountDetails?.profileImgUrl}
                                  alt=""
                                />
                              ) : (
                                <img
                                  style={personIconStyle}
                                  src={PersonIcon}
                                  alt="individual"
                                />
                              )}
                            </>
                          )}
                        </SmallActionButton>
                      </Box>

                      <Box
                        width={"84%"}
                        sx={
                          selectedGroup?.pnId === item?.pnId &&
                          selectedGroup?.name === item?.name
                            ? classes?.selectedItem
                            : classes?.nonselectedItem
                        }
                        padding={"0.2rem 0.4rem"}
                        borderRadius="0.1rem"
                        cursor="pointer"
                        onClick={() => handlegroupItemclick(item)}
                        position={"relative"}
                      >
                        <Box display={"flex"} alignItems={"center"}>
                          <Typography
                            maxWidth={
                              !item?.isGroup &&
                              item?.id === currentUserData?.id
                                ? "60%"
                                : "80%"
                            }
                            fontSize="13px"
                            fontWeight="400"
                            color={
                              selectedGroup?.id === item?.id ? "black" : "black"
                            }
                            variant="h6"
                            title={item?.name}
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.name}
                          </Typography>
                          {!item?.isGroup &&
                            item?.id === currentUserData?.id && (
                              <Typography ml={"0.1rem"} variant="caption">
                                ({appContent?.KEY5})
                              </Typography>
                            )}
                        </Box>
                        {item?.messageCount !== 0 &&
                          item?.pnId !== selectedGroup?.pnId && (
                            <Box
                              position={"absolute"}
                              right={"10%"}
                              top={"48%"}
                              sx={{ transform: "translateY(-48%)" }}
                            >
                              <Badge
                                color="success"
                                badgeContent={item?.messageCount}
                                max={20}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    backgroundColor: "#183243",
                                    fontSize: "0.7rem",
                                  },
                                }}
                              ></Badge>
                            </Box>
                          )}
                      </Box>
                    </Box>

                    {showUnArchiveIcons ? (
                      <Box
                        padding={"0rem 0.1rem 0rem 0rem"}
                        width={"25%"}
                        textAlign={"right"}
                      >
                        <Button
                          onClick={() => handleArchiveClick(item)}
                          size="small"
                          variant="contained"
                          sx={{
                            padding: "0px",
                            backgroundColor: `${colorSchemes.white}`, // always white
                            width: "1.87rem",
                            height: "1.87rem",
                            minWidth: "unset",
                            minHeight: "unset",
                            borderRadius: "0.15rem",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: `${colorSchemes.white}`, // no blue on hover
                              boxShadow: "none",
                            },
                          }}
                        >
                          <UnArchive
                            color={showArchiveIcons ? "#000000" : "#000000"}
                          />{" "}
                          {/* always black */}
                        </Button>
                      </Box>
                    ) : (
                      item?.timetoken !== 0 &&
                      item?.timetoken && (
                        <Box
                          padding={"0rem 0.1rem 0rem 0rem"}
                          width={"25%"}
                          textAlign={"right"}
                        >
                          <Typography
                            variant="h6"
                            fontSize={"0.74rem"}
                            fontWeight={500}
                            color={"#183243"}
                          >
                            {(() => {
                              const timetoken = item?.timetoken;
                              const date = moment(
                                Math.floor(timetoken / 10000)
                              );
                              const isToday = date.isSame(moment(), "day");
                              return isToday
                                ? date.format(
                                    currentUserData?.userTimeFormat
                                  )
                                : date.format(
                                    currentUserData?.userDateFormat
                                  );
                            })()}
                          </Typography>
                        </Box>
                      )
                    )}
                  </div>
                );
              })}
            </>
          )}
        </Box>
      </StyledSideBarInfoBox>
      <Box
        position={"relative"}
        bgcolor={"#F9F8F8"}
        width={"100%"}
        alignSelf={"flex-end"}
        textAlign={"center"}
        mt={"3rem"}
        sx={{
          "@media (max-width: 1194px)": {
            mt: "0rem",
          },
        }}
      >
        <Box
          display={"flex"}
          padding={"0.2rem 0.4rem"}
          bgcolor={"#efefef"}
          alignItems={"center"}
        >
          <SmallActionButton
            size="small"
            variant="contained"
            sx={{
              mr: "0.2rem" ,
              padding: currentUserData?.profileImgUrl ? "0px" : "6px",
              overflow: "hidden",
            }}
           
            onClick={() =>
              handleGroupProfileBadgeClick(currentUserData)
            }
          >
            {currentUserData?.profileImgUrl? 
            <img
            style={{ width: "100%", height: "100%" }}
            src={currentUserData?.profileImgUrl}
            alt=""
          />: 
          <img style={personIconStyle} src={PersonIcon} alt="individual" />}
           
          </SmallActionButton>
          <Typography
            textAlign={"start"}
            width={"80%"}
            fontSize="14px"
            color={"#000000"}
            variant="h6"
            title={`${currentUserData?.firstName} ${currentUserData?.lastName}`}
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {currentUserData?.firstName}{" "}
            {currentUserData?.lastName}
          </Typography>

          <StyledSidebarInvitesButton
            sx={{ fontSize: "0.80rem" }}
            onClick={handleOpenMenu}
          >
            <img src={addIcom} alt="group" />
            <Typography ml={"0.2rem"} fontSize={"0.80rem"}>
              {appContent?.KEY9}
            </Typography>
          </StyledSidebarInvitesButton>

          <InviteMemberDrawer
            isaddmemberOpen={isInviteOpen}
            closePopUp={handleCloseMenu}
            handleGroupProfileBadgeClick={handleGroupProfileBadgeClick}
            classes={classes}
          />
        </Box>
      </Box>
    </Stack>
  );
};

export default SideBar;
